import { useState, useEffect, useCallback } from 'react';

interface UsePageLoadStateReturn {
  isPageLoaded: boolean;
  isMockupVisible: boolean;
  startMockupAnimation: () => void;
}

const usePageLoadState = (): UsePageLoadStateReturn => {
  const [isPageLoaded, setIsPageLoaded] = useState(false);
  const [isMockupVisible, setIsMockupVisible] = useState(false);

  // Funktion zum manuellen Starten der Mockup-Animation
  const startMockupAnimation = useCallback(() => {
    if (isPageLoaded) {
      setIsMockupVisible(true);
    }
  }, [isPageLoaded]);

  useEffect(() => {
    const handleLoad = () => {
      setIsPageLoaded(true);
      // Kleine Verzögerung für sanften Übergang
      setTimeout(() => {
        setIsMockupVisible(true);
      }, 300);
    };

    // Prüfen ob die Seite bereits geladen ist
    if (document.readyState === 'complete') {
      handleLoad();
    } else {
      // Event Listener für das Load-Event
      window.addEventListener('load', handleLoad);
      
      // Fallback für den Fall, dass das Load-Event bereits gefeuert wurde
      const fallbackTimer = setTimeout(() => {
        if (document.readyState === 'complete') {
          handleLoad();
        }
      }, 100);

      return () => {
        window.removeEventListener('load', handleLoad);
        clearTimeout(fallbackTimer);
      };
    }
  }, []);

  return {
    isPageLoaded,
    isMockupVisible,
    startMockupAnimation
  };
};

export default usePageLoadState;
